import { render, staticRenderFns } from "./SupplementaryInsuranceForm.vue?vue&type=template&id=6fd2c8eb"
import script from "./SupplementaryInsuranceForm.vue?vue&type=script&lang=js"
export * from "./SupplementaryInsuranceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports